import { Routes } from '../types';
import { NotificationsPage } from './notifications';
import { StationsPage } from './stations';

export const IRomaScentsPages: Routes = [
    {
        url: 'iromascents',
        permissions: 'readOnly',
        sidebar: {
            icon: 'irs-station',
            name: 'iRomaScents',
            hasNotificationsBadge: true,
        },
        children: [StationsPage, NotificationsPage],
    },
];
